import Reveal from "./Reveal";
import { useT } from "../../i18n/I18nContext";

export const TrustCredibility = () => {
  const t = useT();
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB]">
                {t.trust.eyebrow}
              </p>
            </Reveal>
            <Reveal delay={60}>
              <h2 className="mt-4 text-3xl sm:text-4xl lg:text-[44px] font-bold text-[#0A2342] leading-[1.1] tracking-tight">
                {t.trust.title}
              </h2>
            </Reveal>
            <Reveal delay={120}>
              <p className="mt-5 text-base lg:text-lg text-slate-600 leading-relaxed">
                {t.trust.body}
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              {t.trust.stats.map((s, i) => (
                <Reveal key={s.label} delay={80 * i}>
                  <div
                    data-testid={`trust-stat-${i}`}
                    className="relative bg-[#F8FAFC] rounded-2xl p-7 sm:p-8 border border-slate-100 uv-card-hover h-full"
                  >
                    <p className="font-extrabold text-4xl sm:text-5xl text-[#2563EB] tracking-tight leading-none">
                      {s.value}
                    </p>
                    <p className="mt-3 text-sm sm:text-base font-semibold text-[#0A2342]">
                      {s.label}
                    </p>
                    <span
                      className="absolute top-6 right-6 w-2.5 h-2.5 rounded-full bg-[#10B981]"
                      aria-hidden="true"
                    />
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustCredibility;
